import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { refreshTableCampaignsProducts } from "../../../redux";
import { useCampaignsProducts } from "./useCampaignsProducts";
import { campaignProductsService } from "../../../shared/services";

const { confirm } = Modal;

export const useTableCampaignsProducts = () => {
  const dispatch = useAppDispatch();
  const { tableProps } = useCampaignsProducts();

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar el producto de la campaña con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar producto" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar producto",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await deleteProductForCampaign(valId)
          .then(() => {
            dispatch(refreshTableCampaignsProducts(true));
            message.success(
              `Se ha borrado el producto de la campaña con id:${valId}`
            );
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  const deleteProductForCampaign = async (id: number) => {
    return await campaignProductsService
      .remove(id.toString())
      .then((res: any) => {
        return res;
      })
      .catch((err: any) => {
        return err.message;
      });
  };
  return {
    showDeleteConfirm,
  };
};
